module.exports = __webpack_public_path__ + "img/contact.54450f1d.png";